import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { BscConnector } from '@binance-chain/bsc-connector';
import { BitKeepConnector } from '../../bitkeep/connector';
import { OntoConnector } from '../../onto/connector';
import { MathWalletConnector } from '../../math-wallet/connector';

export const Injected = new InjectedConnector({
    supportedChainIds: [1, 3, 4, 5, 42, 56, 97, 1337]
});

export const WalletConnect = new WalletConnectConnector({
    rpc: { 1: (process.env.REACT_APP_RPC_ETH_MAINNET as string), 56: (process.env.REACT_APP_RPC_BSC_MAINNET as string), 97: (process.env.REACT_APP_RPC_BSC_TESTNET as string) },
    qrcode: true,
    // @ts-ignore
    pollingInterval: 12000
})

export const MathWallet = new MathWalletConnector({
    supportedChainIds: [1, 3, 4, 5, 10, 42, 56, 97, 137, 80001, 1337, 42161, 421611, 43114, 43113]
});

export const BinanceWallet = new BscConnector({
    supportedChainIds: [1, 56, 97]
});

export const BitKeep = new BitKeepConnector({
    supportedChainIds: [1, 3, 4, 5, 10, 42, 56, 97, 137, 80001, 1337, 42161, 421611, 43114, 43113]
});

export const Onto = new OntoConnector({
    supportedChainIds: [1, 3, 4, 5, 10, 42, 56, 97, 137, 80001, 1337, 42161, 421611, 43114, 43113]
});
